var BaseCollection = require('./base-collection');

var MedsidePatientsCollections = BaseCollection.extend({
    url:"/api/organization",
    sortConf: {field: 'patient_name', asc: true},

    initialize: function(models, options) {
    	var url = "/medware/patients?";
    	if(options.variant=="referral")
    		url = "/medware/patientsByReferral?";
    	
        this.url += "/" + options.id + url +
            (options.orgs||[]).map(function(val){return "org=" + val}).join("&");        
        
        if(options.from) this.url += "&from=" + options.from;
        if(options.to) this.url += "&to=" + options.to;
        
    },

    comparator: function(a, b) {
        if (this.sortConf.field == "referral_date" || this.sortConf.field == "soc" || this.sortConf.field == "status"|| this.sortConf.field == "transfer_date") {
            a = new Number(a.get(this.sortConf.field));
            b = new Number(b.get(this.sortConf.field));
        } else {
            a = a.get(this.sortConf.field);
            b = b.get(this.sortConf.field);
        }
        result = a > b ?  1
            : a < b ? -1
            :          0;

        if (!this.sortConf.asc){
            return result * -1;
        }
        return result;
    },

    sortByField: function(fieldName) {
        if (this.sortConf.field != fieldName){
            this.sortConf = {field: fieldName, asc: true};
        } else {
            this.sortConf.asc = !this.sortConf.asc;
        }
        this.sort();
    },

    sortByFieldAndDirection: function (fieldName, direction) {
        this.sortConf = {field: fieldName, asc: direction == "ASC"};
        this.sort();
    }

});


module.exports = MedsidePatientsCollections;


//////////////////
// WEBPACK FOOTER
// ./app/collections/medside-patients-collection.js
// module id = 286
// module chunks = 0